module.exports = __webpack_public_path__ + "media/images/fullscreen/root_homes_keyb_vanilla-1ba28d9cf54315924afcccba2baa5185.png";